import { CHOIX_DE_PRIORITE } from '@nextilt/commun';
import type { Priorite } from '../partage/api/types';
import { FILTRE_TOUT, FILTRER_LA_CARTE, MOTS_PRIORITE } from '../partage/vocabulaire';
import './BarreDeLaCarte.css';

/**
 * Le filtre de la Carte, au-dessus d'elle : les pastilles Tout, Urgent, Important, Quand tu veux,
 * et la phrase qui compte (« 2 bulles urgentes sur 119, dans 2 branches »).
 *
 * **Caché, pas supprimé** (chantier `tete-du-projet`, modification 01, décision 5 d'Igor : « on
 * le garde mais on l'affiche pas, il pourra peut-être servir ») : la barre reste rendue, avec
 * l'attribut `hidden`. Profondeur, Recentrer et Habit sont montés sur la ligne des angles
 * (posés par la feuille dans sa tête). Ce composant ne décide rien : le choix du filtre est
 * tenu par `useCalque`, le compte de la phrase par `filtreDeLaCarte.ts`.
 */
export function BarreDeLaCarte({
  enAvant,
  onFiltrer,
  phrase,
}: {
  enAvant: Priorite | null;
  onFiltrer: (enAvant: Priorite | null) => void;
  /** La phrase du filtre, `null` sans filtre. */
  phrase: string | null;
}) {
  const choix: [Priorite | null, string][] = [
    [null, FILTRE_TOUT],
    ...CHOIX_DE_PRIORITE.map((p): [Priorite, string] => [p, MOTS_PRIORITE[p]]),
  ];
  return (
    <div className="carte-barre" hidden>
      <div className="carte-filtre" role="group" aria-label={FILTRER_LA_CARTE} hidden>
        {choix.map(([p, mot]) => (
          <button
            key={p ?? 'tout'}
            type="button"
            className="carte-filtre-choix"
            aria-pressed={enAvant === p}
            onClick={() => onFiltrer(p)}
          >
            {mot}
          </button>
        ))}
      </div>
      <p className="carte-filtre-phrase" aria-live="polite" hidden>
        {phrase ?? ''}
      </p>
    </div>
  );
}
